/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Nav_Sign_UpInputs */

const en_portal_nav_sign_up = /** @type {(inputs: Portal_Nav_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create account`)
};

const pl_portal_nav_sign_up = /** @type {(inputs: Portal_Nav_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz konto`)
};

/**
* | output |
* | --- |
* | "Create account" |
*
* @param {Portal_Nav_Sign_UpInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_nav_sign_up = /** @type {((inputs?: Portal_Nav_Sign_UpInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Nav_Sign_UpInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_nav_sign_up(inputs)
	return en_portal_nav_sign_up(inputs)
});